module.exports = __webpack_public_path__ + "img/fashionx-logo-web.49186f2.png";